/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// import core & vendor packages below
import React, { useState } from 'react';
import { Row, Col, Button, Form, FormControl } from 'react-bootstrap';

// import components below
import { requestStatus } from 'helpers';
import Table from 'components/ReactTable';

// import assets below
import './index.scss';

const state = [
  {
    id: '001',
    employee_name: 'Juan Dela Cruz',
    leave_start: 'July 4, 2022',
    leave_end: 'July 7, 2022',
    leave_type: 'Details Here',
    status: 'Approved',
  },
  {
    id: '001',
    employee_name: 'Juan Dela Cruz',
    leave_start: 'July 4, 2022',
    leave_end: 'July 7, 2022',
    leave_type: 'Details Here',
    status: 'Denied',
  },
  {
    id: '001',
    employee_name: 'Juan Dela Cruz',
    leave_start: 'July 4, 2022',
    leave_end: 'July 7, 2022',
    leave_type: 'Details Here',
    status: 'Pending',
  },
];

// main component
const index = ({ setShowScreen, setRequestData }) => {
  const tableColumns = React.useMemo(
    () => [
      { Header: 'ID', accessor: 'id' },
      { Header: 'Employee Name', accessor: 'employee_name' },
      { Header: 'Leave Start', accessor: 'leave_start' },
      { Header: 'Leave End', accessor: 'leave_end' },
      { Header: 'Leave Type', accessor: 'leave_type' },
      { Header: 'Status', accessor: 'status' },
    ],
    [],
  );

  const tableData = React.useMemo(
    () =>
      state?.map((dd) => ({
        id: dd?.id,
        employee_name: dd?.employee_name,
        leave_start: dd?.leave_start,
        leave_end: dd?.leave_end,
        leave_type: dd?.leave_type,
        status: requestStatus(dd?.status),
      })),
    [state],
  );

  return (
    <div className='advances-table'>
      <div className='main-table'>
        <Table
          data={tableData}
          columns={tableColumns}
          pagination={['BOTTOM']}
          customAction={(id, data) => {
            return (
              <div className='advance-actions'>
                <Button
                  className='add-payroll'
                  onClick={() => {
                    setShowScreen(2);
                    setRequestData(data);
                  }}
                >
                  Leave Request
                </Button>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default index;
